import {
  ROLE_START,
  ROLE_DATA,
  ROLE_GETBY,
  ROLE_END,
  ROLE_PERMISSION,
  ROlE_CREATE,
  ROLE_UPDATE
} from "../../slices/type";

interface InitState {
  data: any[];
  Permission: any[];
  create: any[];
  update:any[];
  getByID: any[];
  dataSingle: any[];
  loading: boolean;
}

const initState: InitState = {
  data: [],
  dataSingle: [],
  Permission: [],
  create: [],
  update:[],
  getByID: [],
  loading: false,
};

interface Action {
  type: string;
  payload?: any;
  loading?: boolean;
}

const Role_Red = (state = initState, action: Action): InitState => {
  switch (action.type) {
    case ROLE_START:
      return {
        ...state,
        loading: action.loading ?? false,
      };
    case ROLE_DATA:
      return {
        ...state,
        data: action.payload ?? [],
        loading: action.loading ?? false,
      };
    case ROLE_PERMISSION:
      return {
        ...state,
        Permission: action.payload ?? [],
        loading: action.loading ?? false,
      };
    case ROlE_CREATE:
      return {
        ...state,
        create: action.payload ?? [],
        loading: action.loading ?? false,
      };
    case ROLE_GETBY:
      return {
        ...state,
        getByID: action.payload ?? [],
        loading: action.loading ?? false,
      };

      case ROLE_UPDATE:
      return {
        ...state,
        update: action.payload ?? [],
        loading: action.loading ?? false,
      };  
    case ROLE_END:
      return {
        ...state,
        dataSingle: action.payload ?? [],
        loading: action.loading ?? false,
      };
    default:
      return state;
  }
};

export default Role_Red;
